import React from "react";
import { Typography, Box, Link, Container } from "@material-ui/core";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import { CONTACT_US_EMAIL } from "../../constants";
import moment from "moment";
import { useRecoilValue } from "recoil";
import { hidePanelState } from "../../recoil/General/atom";

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const hidePanel = useRecoilValue(hidePanelState);

  return (
    <footer>
      <Container maxWidth="xl" className={classes.root}>
        <Box
          textAlign="right"
          py={2}
          className={`${hidePanel ? "" : classes.hideFooter}`}
        >
          <Typography variant="body2" className="f-gray font-13">
            <Link
              target="_blank"
              href={`mailto:${CONTACT_US_EMAIL}`}
              className={classes.link}
            >
              {t("login.contactUs")}
            </Link>
            {/* {`${t("login.copyrightText")}@${moment().format("YYYY")}, ${t(
            "login.TargetCW"
          )}`} */}
            Copyright &#169; {moment().format("YYYY")} iAlign
          </Typography>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;
